import React from 'react';
import JournalAnalysis from '../components/Journal/Analysis';

const JournalAnalysisView = () => {
    return <JournalAnalysis />;
};

export default JournalAnalysisView;
